import ComplaintInput from "../ComplaintHeader/ComplaintInput";
import ComplaintInfo from "../ComplaintInfo/ComplaintInfo";
import WaveDesign from "../Wave/WaveDesign";
import ContactUsForm from "./ContactUsForm";
import React from "react";

/** @import {ContactUsFullFormProps} from './ContactUsFormTypes' */
function ContactUsFullForm(/** @type {ContactUsFullFormProps} */ props) {
    return (
        <div className="complaint-parent">
            <ComplaintInput />
            <ComplaintInfo />
            <WaveDesign/>
            <ContactUsForm profile={props.profile}  />
        </div>
    );
}

export default ContactUsFullForm;